import { Component, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { ContactGroupService } from '@app/services/contact-group.service';
import { SidebarService } from '@services/sidebar.service';

@Component({
  selector: 'app-contact-group-view-users',
  templateUrl: './contact-group-view-users.component.html',
  styleUrls: [],
  providers: [SidebarService]
})
@Injectable()
export class ContactGroupViewUsersComponent extends BaseComponent {

  public contactGroup: {
    name: string,
    uuid: string,
    created_by_user: any,
    created_user: any,
    created_at: string,
    userCount: number,
    users: any
  };
  public dataLoaded = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public contactGroupService: ContactGroupService,
    public sidebarService: SidebarService,
    public state: State,
    public router: Router
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService,
      state,
      router,
      modelService: contactGroupService
    });
    this.setPageVars({
      sidebar: ''
    });
    this.modelServiceGetOne(this.routeParams['id'], 'contactGroup').then(() => {
      this.dataLoaded = true;
    });
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
